import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {CurationEditorAberrationComponent} from '../curation-editor/aberration/curation-editor-aberration.component';
import {CurationEditorClinicalTrialComponent} from '../curation-editor/clinical-trial/curation-editor-clinical-trial.component';
import {CurationPathwaysBpmnComponent} from '../curation-editor/pathways-bpmn/curation-pathways-bpmn.component';
import {CurationEditorPlacementComponent} from '../curation-editor/placement/curation-editor-placement.component';
import {CurationEditorRegimenComponent} from '../curation-editor/regimen/curation-editor-regimen.component';
import {CurationEditorReportComponent} from '../curation-editor/report/curation-editor-report.component';
import {CurationEditorTreatmentPlanComponent} from '../curation-editor/treatmentplan/curation-editor-treatment-plan-component';
import {CurationEditorTreatmentProtocolComponent} from '../curation-editor/treatmentprotocol/curation-editor-treatmentprotocol.component';
import {CurationSettings} from "../curation-dashboard/curation-setting";
import {RouterManagerService} from "@ispm/core/services/router-manager.service";

@Component({
  selector: 'curation-container-component',
  template: `
    <ng-container *ngComponentOutlet="curationCurrentComponent"></ng-container>`
})
export class CurationContainerComponent implements OnInit {
  curationCurrentComponent: any;

  constructor(private routerManagerService: RouterManagerService) {
  }

  ngOnInit() {
    switch (this.routerManagerService.parameters.curationType) {
      case CurationSettings.CURATION_REGIMEN:
        this.curationCurrentComponent = CurationEditorRegimenComponent;
        break;
      case CurationSettings.CURATION_PATHWAY_BPMN:
        this.curationCurrentComponent = CurationPathwaysBpmnComponent;
        break;
      case CurationSettings.CURATION_ABERRATION:
        this.curationCurrentComponent = CurationEditorAberrationComponent;
        break;
      case CurationSettings.CURATION_CLINICAL_TRIAL:
        this.curationCurrentComponent = CurationEditorClinicalTrialComponent;
        break;
      case CurationSettings.CURATION_TREATMENTPLAN:
        this.curationCurrentComponent = CurationEditorTreatmentPlanComponent;
        break;
      case CurationSettings.CURATION_TREATMENTPROTOCOL:
        this.curationCurrentComponent = CurationEditorTreatmentProtocolComponent;
        break;
      case CurationSettings.CURATION_PLACEMENT:
        this.curationCurrentComponent = CurationEditorPlacementComponent;
        break;
      case CurationSettings.CURATION_SUMMARY:
        this.curationCurrentComponent = CurationEditorReportComponent;
        break;
      case CurationSettings.CURATION_CLINICALTRIAL:
        this.curationCurrentComponent = CurationEditorReportComponent;
        break;
      case CurationSettings.CURATION_PATHWAY:
        this.curationCurrentComponent = CurationEditorReportComponent;
        break;
      default:
    }
  }
}
